export const dashboardFiltersEnum = {
  VIEW_TYPE: 'view-type',
  RANGE_PERIOD: 'range-period',
  CARRIER_LIST: 'carrier-list',
};
